import { render } from "./PhoneField.vue?vue&type=template&id=b6ac6bec&scoped=true&ts=true"
import script from "./PhoneField.vue?vue&type=script&lang=ts"
export * from "./PhoneField.vue?vue&type=script&lang=ts"

import "./PhoneField.vue?vue&type=style&index=0&id=b6ac6bec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6ac6bec"]])

export default __exports__